export default __webpack_public_path__ + "static/media/Vips-Cambio.f1e0b8db.png";